import { render, staticRenderFns } from "./Image3D.vue?vue&type=template&id=02efadfa&scoped=true&"
import script from "./Image3D.vue?vue&type=script&lang=js&"
export * from "./Image3D.vue?vue&type=script&lang=js&"
import style0 from "./Image3D.vue?vue&type=style&index=0&id=02efadfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02efadfa",
  null
  
)

export default component.exports